(function () {
  function enhanceTurkeyTailReview() {
    var root = document.querySelector('.tt-review-summary--yotpo');
    if (!root || root.classList.contains('tt-review-enhanced')) return;

    var ratingText = root.querySelector('.sr-only');
    var countLink = root.querySelector('.text-m');
    if (!ratingText || !countLink) return;

    var ratingMatch = ratingText.textContent.match(/([0-5](?:\.\d+)?)/);
    var countMatch = countLink.textContent.match(/([\d,]+)/);
    if (!ratingMatch || !countMatch) return;

    var rating = Math.max(0, Math.min(5, parseFloat(ratingMatch[1])));
    var display = document.createElement('div');
    display.className = 'tt-review-dynamic-display';
    display.setAttribute('aria-label', rating + ' out of 5 stars, ' + countMatch[1] + ' reviews');

    var stars = document.createElement('span');
    stars.className = 'tt-review-dynamic-stars';
    stars.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < 5; i += 1) {
      var fill = Math.max(0, Math.min(100, (rating - i) * 100));
      var star = document.createElement('span');
      star.className = 'tt-review-dynamic-star';
      star.style.setProperty('--tt-star-fill', fill + '%');
      star.textContent = '★';
      stars.appendChild(star);
    }

    var score = document.createElement('strong');
    score.className = 'tt-review-dynamic-score';
    score.textContent = rating.toFixed(1);

    var count = document.createElement('a');
    count.className = 'tt-review-dynamic-count';
    count.href = '#';
    count.textContent = '(' + countMatch[1] + ' Reviews)';
    count.addEventListener('click', function (event) {
      event.preventDefault();
      countLink.click();
    });

    display.appendChild(stars);
    display.appendChild(score);
    display.appendChild(count);
    root.appendChild(display);
    root.classList.add('tt-review-enhanced');
  }

  function startTurkeyTailReview() {
    enhanceTurkeyTailReview();
    var root = document.querySelector('.tt-review-summary--yotpo');
    if (!root) return;
    var observer = new MutationObserver(enhanceTurkeyTailReview);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startTurkeyTailReview);
  } else {
    startTurkeyTailReview();
  }
}());

(function () {
  var styleId = 'mt-physical-iphone-final-20260902';
  if (document.getElementById(styleId)) return;

  var style = document.createElement('style');
  style.id = styleId;
  style.textContent = '@media (max-width: 719px) {' +
    '.tt-pdp figure[data-product-image="tt-science"] > .tt-gallery-card.mt-editorial-card,' +
    '.tt-pdp figure[data-product-image="tt-quality"] > .tt-gallery-card.mt-editorial-card{' +
      'grid-template-columns:35% 65%!important;' +
      'width:105%!important;max-width:none!important;' +
      'margin-left:-2.5%!important;margin-right:-2.5%!important;' +
    '}' +
    '.tt-pdp figure[data-product-image="tt-science"] .mt-editorial-copy{' +
      'padding:17px 14px 17px 22px!important;' +
    '}' +
    '.tt-pdp figure[data-product-image="tt-quality"] .mt-editorial-copy{' +
      'padding:11px 10px!important;' +
    '}' +
    '.tt-pdp figure[data-product-image="tt-quality"] .tt-gallery-quality-tags{' +
      'display:flex!important;flex-direction:column!important;align-items:stretch!important;' +
      'width:100%!important;min-width:0!important;margin:8px 0 0!important;' +
    '}' +
    '.tt-pdp figure[data-product-image="tt-quality"] .tt-gallery-quality-tags i{' +
      'display:flex!important;align-items:center!important;justify-content:center!important;' +
      'align-self:stretch!important;justify-self:stretch!important;grid-column:auto!important;' +
      'min-width:0!important;width:100%!important;max-width:none!important;margin:0!important;' +
      'min-height:34px!important;height:auto!important;padding:7px 6px!important;' +
      'box-sizing:border-box!important;font-size:9px!important;line-height:1.18!important;' +
      'letter-spacing:0!important;white-space:normal!important;word-break:normal!important;' +
      'overflow-wrap:normal!important;hyphens:none!important;overflow:visible!important;' +
      'text-align:center!important;border:0!important;' +
    '}' +
    '.tt-pdp figure[data-product-image="tt-quality"] .tt-gallery-quality-tags i + i{' +
      'border-top:1px solid rgba(42,75,35,.28)!important;' +
    '}' +
  '}';
  document.head.appendChild(style);
}());
